import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (token) {
            try {
                // Decode JWT payload (base64)
                const payload = JSON.parse(atob(token.split('.')[1]));
                // Check expiry
                if (payload.exp * 1000 > Date.now()) {
                    setUser({
                        id: payload.id,
                        username: payload.username,
                        role: payload.role,
                        warehouse: payload.warehouse
                    });
                } else {
                    // Token expired
                    localStorage.removeItem('token');
                    setToken(null);
                    setUser(null);
                }
            } catch {
                localStorage.removeItem('token');
                setToken(null);
                setUser(null);
            }
        }
        setLoading(false);
    }, [token]);

    const login = (tokenStr, userData) => {
        localStorage.setItem('token', tokenStr);
        setToken(tokenStr);
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setToken(null);
        setUser(null);
    };

    const isAuthenticated = !!user && !!token;

    const hasRole = (...roles) => {
        return user && roles.includes(user.role);
    };

    return (
        <AuthContext.Provider value={{ user, token, login, logout, isAuthenticated, hasRole, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
